export const TAB_TITLES = {
    payouts: 'Payouts',
    charges: 'Charges',
};
export const tagsAppearances = {
    PAID: 'success',
    PROCESSING: 'alert',
    FAILED: 'critical',
    REVERTED: 'alert',
};
